import { MSAData, MSASequence } from '../types';

/**
 * Validate MSA data structure
 */
export function validateMSAData(data: any): data is MSAData {
  if (!data || typeof data !== 'object') {
    return false;
  }

  if (!Array.isArray(data.sequences)) {
    return false;
  }

  // Check that all sequences are valid
  for (const sequence of data.sequences) {
    if (!validateMSASequence(sequence)) {
      return false;
    }
  }

  return true;
}

/**
 * Validate individual MSA sequence
 */
export function validateMSASequence(sequence: any): sequence is MSASequence {
  if (!sequence || typeof sequence !== 'object') {
    return false;
  }

  if (typeof sequence.name !== 'string' || sequence.name.length === 0) {
    return false;
  }

  if (typeof sequence.sequence !== 'string' || sequence.sequence.length === 0) {
    return false;
  }

  return true;
}